import React from 'react'
import { Container, Row, Col, Image, Card } from "react-bootstrap";

import Mission from '../../Assets/mission.png';
import Vision from '../../Assets/vision.png';

export default function WhatWeDoBestCard() {
    return (
        <section className='py-5 bg-dark'>
            <Container>
                <Row className="text-white">
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What Drives Us <span className="text-gradient-1">Forward</span></h2>
                        <h5 className='heading-style-h5 pb-5'>What we stand for as a company, and where we aim to go. </h5>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="d-flex ">
                        <Card className="rounded-0 dark-card col-md-6">
                            <Card.Body className='p-4 d-flex flex-column'>
                                <Image src={Mission} className='w-56 mb-3' />
                                <h5 className="heading-style-h5 mb-3">Mission </h5>
                                <p>We focus on getting things right at the engineering level, not just delivering outcomes </p>
                            </Card.Body>
                        </Card>
                        <Card className="rounded-0 dark-card col-md-6">
                            <Card.Body className='p-4 d-flex flex-column'>
                                <Image src={Vision} className='w-56 mb-3' />
                                <h5 className="heading-style-h5 mb-3">Vision</h5>
                                <p>To grow into a trusted global partner known for disciplined execution, dependable systems and long-term relationships built on trust. </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
